import {Component, OnInit, Renderer2} from '@angular/core';
import { Messaging, getToken } from '@angular/fire/messaging';
import {environment} from '../environments/environment';
import {HttpClient} from '@angular/common/http';
import { Subscription } from 'rxjs';
import { ThemeService } from './services/theme.service';
import * as pdfjsLib from 'pdfjs-dist';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  readonly tokenRegistrationUrl = environment.backendUrl + '/kontaflow/task/app/capture/notif/subscribe?token=';

  constructor(private messaging: Messaging,
              private http: HttpClient,
              private themeService: ThemeService,
              private renderer: Renderer2) {

  }


  ngOnInit(): void {
    this.requestPermission();
    // this.afMessaging.messages.subscribe(
      //   message => console.log('message:' + message)
      // );
    this.themeService.darkMode$.subscribe(isDark => {
      if (isDark) {
        this.renderer.addClass(document.body, 'dark-theme');
      } else {
        this.renderer.removeClass(document.body, 'dark-theme');
      }
    });

    pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;
  }

  requestPermission() {
    getToken(this.messaging, { vapidKey: 'YOUR_VAPID_KEY' })
      .then(
        (token) => {
          console.log('this.afMessaging.requestToken: ' + token);
          // register token into Konta API

          console.log('Sending token to server...');


          this.http.post<any>(this.tokenRegistrationUrl + token, {})
            .subscribe(
              () => {
                // this.setTokenSentToServer(true);
                console.log('Posting token to API...');

              }
            );
        }
      ).catch((err) => {
        console.error('Unable to get permission to notify.', err);
      });
  }


}

